export const getLocaleFromCookie = (): string | undefined => {
  const localeCookie = document.cookie.match(new RegExp("(^| )locale=([^;]+)"));
  if (localeCookie) return localeCookie[2];

  return undefined;
};
